export const OWNER = {
    ALL: 'all',
    ME: 'me',
    OTHER: 'other',
}

export const SORT_BY = {
    LAST_UNREAD_INBOUND: 'lastUnreadInbound',
    LAST_SENT: 'lastSent',
    LAST_SENT_30_DAYS: 'lastSent30Days',
    LAST_UNREAD_OUTBOUND: 'lastUnreadOutbound',
}